import Header from './../../../../Headers/HeaderForAreLoggedIn/index.vue'
import ProgressHUD from './../../../../ProgressHUD/index.vue'
import UserInfo from './../BaseComponents/UserInfo/index.vue'
import CompanyInfo from './../BaseComponents/CompanyInfo/index.vue'
import { Api, Toast } from './../../../../../services'

export default {
  name: 'CarbonEnergyGeneratior',
  props: [],
  components: {
    Header,
    ProgressHUD,
    UserInfo,
    CompanyInfo,
  },
  methods: {
    async send() {
      try {
        if (this.$refs.termsAndConditions_Yes.checked == false) {
          Toast.error({
            toast: this.$toast,
            title: 'Error',
            message: 'You must accept terms and conditions first',
          })

          return
        }

        var isValidUserInfo = await this.$refs.userInfo.isValid()
        var isValidCompanyInfo = await this.$refs.companyInfo.isValid()

        if (!isValidUserInfo || !isValidCompanyInfo) {
          Toast.validationFieldsError({ toast: this.$toast })
          return
        }

        this.$refs.progress.show()

        var requestData = {
          switchRoleTo: 'affiliate',
          user: this.$refs.userInfo.getData(),
          company: this.$refs.companyInfo.getData(),
        }

        var responseData = await Api.setPermission(requestData)
        var results = responseData.data.results
        if (results == 'success') {
          this.$router.push('/dashboard')
        } else {
          Toast.error({
            toast: this.$toast,
            title: 'Error',
            message: 'Something went wrong',
          })
        }
      } catch (error) {
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })

        console.error(error)
      } finally {
        this.$refs.progress.hide()
      }
    },
    checked(firstEl, secEl) {
      $(secEl).prop('checked', !$(firstEl).is(':checked'))
    },
  },
  async created() {
    try {
      var response = await Api.myProfile()

      this.$refs.userInfo.setData(response.data.results.user)
      this.$refs.companyInfo.setData(response.data.results.company)

      this.$nextTick(function() {
        $('select').material_select()
        Materialize.updateTextFields()
      })
    } catch (error) {
      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      })

      console.error(error)
    } finally {
      this.$refs.progress.hide()
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/Account/Permissions/Roles/Affiliate/Affiliate.component.js